/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
/**
 * GetAvailableLanguages Input Action
 */
export class GetAvailableLanguagesInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `availableLanguages`;
    public getCacheObjectType = () => 'availableLanguages';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}
export interface IGetAvailableLanguagesData {
    key: string;
    value: string;
}

const createInput = (): Msdyn365.IActionInput => {
    return new GetAvailableLanguagesInput();
};

async function action(_input: GetAvailableLanguagesInput, ctx: Msdyn365.IActionContext): Promise<IGetAvailableLanguagesData[]> {
    let result: any[] = [];
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetAllChannelLanguages`,
        'get',
        {},
        {
            headers: { oun: ctx.requestContext.apiSettings.oun }
        }
    )
        .then(res => {
            result = (res?.data as any).value;
        })
        .catch(ex => {
            console.log('Error', ex);
        });

    const availableLanguages = result.map((val: any) => {
        return { key: val.ChannelLanguageCode, value: val.ChannelLanguageName };
    });

    return availableLanguages;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAvailableLanguagesData[]>>action,
    id: 'GetAvailableLanguages',
    input: createInput
});
